import React, { useEffect, useState, Fragment } from 'react';
import { Row, Col, Card, Typography, Empty, message } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useDispatch, useSelector } from 'react-redux';
import { getProductSalesListing } from '../ducks/actions'
import { exportSalesReport } from '../ducks/services'
import Search from './components/Search';
import dayjs from 'dayjs';
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { comma } from 'Features/utility';
import { useTranslate } from 'Translate';

const { Title, Text } = Typography;
const _ = require('lodash');

export default (props) => {
  const dispatch = useDispatch();
  const orders = useSelector((state) => state.reporting.productSalesListing);
  const meta = useSelector((state) => state.reporting.productSalesListingOption);
  const [searchVal, setSearchVal] = useState(null);
  const [outlets, setOutlets] = useState([]);
  const [products, setProducts] = useState([]);
  const i18n = useTranslate();
      const { t } = i18n;

  const btnList = [
    {
      text: t("General.export_report"),
      classes: 'green-btn',
      action: () => exportReport(),
    }
  ];

  useEffect(() => {
    dispatch(getProductSalesListing(searchVal, props.setLoading, "1"));
    dispatch(getListQueryItems('setupListQuery', null));
  }, []);

  useEffect(() => {
    if (meta) {
      if ("locations" in meta) {
        let temp = [];
        meta.locations?.map((x, ind) => {
          if(ind === 0) {
            temp.push({
              label: t("General.all_outlets"),
              value: null
            })
          }
          temp.push({
            label: `${x.code} - ${x.desc}`,
            value: x.id
          })
        });
        setOutlets(temp);
      }
      if ("products" in meta) {
        let temp = [];
        meta.products?.map((x, ind) => {
          temp.push({
            label: `${x.code} - ${x.name}`,
            value: x.id
          })
        });
        setProducts(temp);
      }
    }
  }, [meta]);

  const onSearch = (search) => {
    if (search && 'outlet' in search) {
      let searching = {};
      let temp = [];
      if (search?.products?.length > 0) {
        search?.products?.map(x => {
          temp.push(x.value)
        });
      }
      searching = {
        location_id: search?.outlet?.value,
        date_from: search?.start_date ? dayjs(search?.start_date).format("YYYY-MM-DD") : "",
        date_to: search?.end_date ? dayjs(search?.end_date).format("YYYY-MM-DD") : "",
        products: temp,
        is_non_sales: search?.non_sales?.value
      };
      setSearchVal(searching);
      dispatch(getProductSalesListing(searching, props.setLoading));
    } else {
      setSearchVal(null);
      dispatch(getProductSalesListing(null, props.setLoading));
    }
  };

  const exportReport = async () => {
    if (orders?.total_count === 0) {
      return message.warning(t("General.no_data_export"));
    }
    props.setLoading(true);

    await exportSalesReport(searchVal, "product_sales_listing").then((res) => {
      props.setLoading(false);
      if (res.data) {
        const aElement = document.createElement('a');
        let filename = res.headers["x-filename"];
        aElement.setAttribute('download', filename ?? "sample.pdf");
        const href = URL.createObjectURL(res.data);
        aElement.href = href;
        aElement.setAttribute('target', '_blank');
        aElement.click();
        URL.revokeObjectURL(href);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={t("General.product_sales_report")} btnList={allowed([AllRoles.REPORTING.SALES_PAYMENT], 'write') ? btnList : null} />
        </Col>
        <Col span={24} className="">
          <Card bordered={false}>
            <Search onSearch={onSearch} field1={outlets} field2={products} />

            <div className="table-responsive" style={{ overflowX: 'auto', marginTop: "30px" }}>
              <table className='table table-borderless w-100' style={{ borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th>{t("General.item")}</th>
                    <th className='text-right'>{t("Inventory.gross_amt")}</th>
                    <th className='text-right'>{t("Delete.discount")}</th>
                    <th className='text-right'>{t("Crm.net_sales")}</th>
                    <th className='text-right'>{t("General.tax")}</th>
                    <th className='text-right'>{t("SalesReporting.item_qty")}</th>
                    <th className='text-right'>{t("SalesReporting.trans_count")}</th>
                    <th className='text-right'>{t("Inventory.inv_dot_cost")}</th>
                    <th className='text-right'>{t("SalesReporting.gross_profit")}</th>
                    <th className='text-right'>{t("SalesReporting.gross_profit_perc")}</th>
                    <th className='text-right'>{t("Inventory.inv_unit_cost")}</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    orders?.list?.length <= 0 &&
                    <tr>
                      <td colSpan="11">
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                      </td>
                    </tr>
                  }
                  {
                    orders?.list?.length > 0 &&
                    orders?.list?.map((x, ind) => {
                      return (
                        <Fragment key={ind}>
                          <tr>
                            <td colSpan="11" className='fwbold'>{"Business Date: "} {x.date}</td>
                          </tr>
                          {
                            x.list?.map((y, yIndex) => {
                              return (
                                <Fragment key={yIndex}>
                                  <tr>
                                    <td colSpan="11" style={{ paddingLeft: "20px" }}>{y.location_code}</td>
                                  </tr>
                                  {
                                    y.list.map((z, zIndex) => {
                                      return (
                                        <tr key={zIndex}>
                                          <td style={{ paddingLeft: "35px" }}>{z.code}-{z.name}</td>
                                          <td align='right'>{comma(parseFloat(z.gross_amount_excl).toFixed(2))}</td>
                                          <td align='right'>{comma(parseFloat(z.discount_amount).toFixed(2))}</td>
                                          <td align='right'>{comma(parseFloat(z.net_sales).toFixed(2))}</td>
                                          <td align='right'>{comma(parseFloat(z.tax_amount).toFixed(2))}</td>
                                          <td align='right'>{comma(z.quantity)}</td>
                                          <td align='right'>{comma(z.trans_count)}</td>
                                          <td align='right'>{comma(parseFloat(z.cost).toFixed(8))}</td>
                                          <td align='right'>{comma(parseFloat(z.profit).toFixed(2))}</td>
                                          <td align='right'>{comma(parseFloat(z.profit_perc).toFixed(2))}</td>
                                          <td align='right'>{comma(parseFloat(z.unit_cost).toFixed(6))}</td>
                                        </tr>
                                      )
                                    })
                                  }
                                  <tr className='bg-gray text-white fwbold'>
                                    <td align='' colSpan="1" style={{ paddingLeft: "20px" }}>{t("Crm.subtotal")}</td>
                                    {
                                      y?.sub_totals && Object.entries(y?.sub_totals)?.map(([key, data], zIndex) => {
                                        return (
                                          <td key={zIndex} align='right'>{comma(data)}</td>
                                        )
                                      })
                                    }
                                  </tr>
                                </Fragment>
                              )
                            })
                          }
                          <tr className='bg-gray text-white fwbold'>
                            <td align='' colSpan="1">{t("Crm.subtotal")}</td>
                            {
                              x?.sub_totals && Object.entries(x?.sub_totals)?.map(([key, data], zIndex) => {
                                return (
                                  <td key={zIndex} align='right'>{comma(data)}</td>
                                )
                              })
                            }
                          </tr>
                        </Fragment>
                      )
                    })
                  }
                  <tr className='bg-gray fwbold text-white'>
                    {
                      orders?.list?.length <= 0
                        ? <td colSpan="11">{t("SalesReporting.grand_total")}</td>
                        : <td align='' colSpan="1">{t("SalesReporting.grand_total")}</td>
                    }
                    {
                      orders?.grand_totals && Object.entries(orders?.grand_totals)?.map(([key, data], index) => {
                        return (
                          <td key={index} align='right'>
                            {comma(data)}
                          </td>
                        )
                      })
                    }
                  </tr>
                </tbody>
              </table>
            </div>
          </Card>
        </Col>
      </Row>
    </>
  )
}